module.exports = __webpack_public_path__ + "img/wander-set-position.6742b1eb.png";